import createQuickAddRequest from 'components/shared/product/quick-add/request'

export default createQuickAddRequest
export {
  getCartQuantity,
  unavailableSize,
} from 'components/shared/product/quick-add/request'
